import { BUTTON_COLOR_PATH } from '@wix/communities-blog-client-common/dist/src/constants/wix-params';
import withSettingsColor from './with-settings-color';

export default withSettingsColor(BUTTON_COLOR_PATH, 'buttonColor', 'color-8', 1);
